// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f713d6f","667":"4413cec5"}[chunkId] + ".chunk.js";
};